import React, { memo } from 'react';

/**
 * Card de item com barra de ações inferior.
 * 
 * Props:
 *   children   — conteúdo principal do card
 *   onEdit     — callback ao clicar em Editar (omitir para esconder)
 *   onDelete   — callback ao clicar em Excluir (omitir para esconder)
 *   actions    — nós React extras na barra de ações (opcional)
 */
const ItemCard = memo(function ItemCard({ children, onEdit, onDelete, actions }) {
  const temAcoes = onEdit || onDelete || actions;
  return (
    <div className="item-card">
      <div className="item-card-body">
        {children}
        {temAcoes && (
          <div
            className="item-card-acoes"
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
          >
            {actions}
            {onEdit && (
              <button type="button" className="item-card-btn" onClick={onEdit}>Editar</button>
            )}
            {onDelete && (
              <button type="button" className="item-card-btn item-card-btn--danger" onClick={onDelete}>Excluir</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default ItemCard;
